import type { LocaleTextJson } from "./localeText";
import { mapPrice, type Price, type PriceJson } from "./Price";
import { type ProfileId, parseProfileV2 } from "./ProfileId";

export interface ProductJson {
	id: number;
	profileDescription: LocaleTextJson;
	profileId: number;
	profileName: LocaleTextJson;
	prices: PriceJson[];
}

interface Filter {
	zoneListMustEqual: string[] | null;
	zoneListMustBeSubsetOf: string[] | null;
	zoneListMustBeSupersetOf: string[] | null;
}

interface PriceVariableAmountJson {
	priceContextId: string;
	minAmount: number;
	maxAmount: number;
	vatPercent: number;
	description: string;
}

export interface ProductV2Json {
	id: string;
	compoundId: string;
	compoundIdAlternate: string;
	calendarRef: null | string;
	productTemplateIdV1: number | null;
	presetZoneIds: string[] | null;
	prices: PriceJson[];
	profileNamePlural: LocaleTextJson;
	profileDescription: LocaleTextJson;
	profileId: string;
	profileName: LocaleTextJson;
	serviceProfileId: string;
	userDetailId: string;
	isCarnetProduct: boolean;
	mediaTypes: string[];
	productIdV1: number | null;
	nrOfMinutesValid: Array<{
		nrOfMinutesValid: number;
		nrOfZones: number;
	}> | null;
	nrOfZonesGetAll: number | null;
	filters: Filter | null;
	profileIdV1: number | null;
	priceVariableAmount: PriceVariableAmountJson | null;
}

export interface Product {
	id: string;
	prices: Price[];
	version: "V1" | "V2";
	filters: Filter | null;
	profileId: ProfileId;
	profileDescription?: string;
}

export const mapProduct = (json: ProductJson | ProductV2Json): Product => {
	const version = typeof json.id === "string" ? "V2" : "V1";
	const profileDescription =
		version === "V2" ? json.profileDescription : undefined;

	return {
		id: json.id.toString(),
		prices: json.prices.map(mapPrice),
		version,
		profileId: parseProfileV2(json.profileId),
		filters: "filters" in json ? json.filters : null,
		profileDescription: profileDescription?.nb || undefined,
	};
};
